<template>
  <div class="min-h-screen bg-base-100">
    <div class="container mx-auto px-4 py-12">
      <div class="max-w-4xl mx-auto">
        <h1 class="text-4xl font-bold text-base-content mb-8">
          Preguntas Frecuentes (F.A.Q.)
        </h1>

        <div class="prose prose-lg max-w-none">
          <p class="text-lg text-base-content/80 mb-8">
            Aquí encontrarás respuestas a las preguntas más frecuentes sobre
            nuestros viajes y servicios. Si no encuentras la respuesta que
            buscas, no dudes en contactarnos.
          </p>

          <div class="space-y-4">
            <!-- Reservas y Pagos -->
            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                💳 ¿Cómo puedo hacer una reserva?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  Puedes hacer una reserva a través de nuestro sitio web, por
                  teléfono o por email. Te enviaremos un contrato de viaje que
                  deberás completar y firmar. Para confirmar tu reserva,
                  necesitarás realizar el pago inicial especificado en el
                  contrato.
                </p>
              </div>
            </div>

            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                💰 ¿Qué métodos de pago aceptan?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  Aceptamos transferencias bancarias, tarjetas de crédito y
                  débito. Los detalles específicos del pago se incluirán en tu
                  contrato de viaje. Normalmente requerimos un depósito inicial
                  para confirmar la reserva y el pago final antes de la fecha de
                  salida.
                </p>
              </div>
            </div>

            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                ❌ ¿Qué pasa si necesito cancelar mi viaje?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  Las condiciones de cancelación varían según el viaje y se
                  especifican en tu contrato. Recomendamos encarecidamente
                  contratar un seguro de cancelación. Si necesitas cancelar,
                  debes notificárnoslo por email a
                  <a
                    href="mailto:info@soleando.eu"
                    class="text-primary hover:underline"
                    >info@soleando.eu</a
                  >
                  lo antes posible.
                </p>
              </div>
            </div>

            <!-- Seguros -->
            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                🛡️ ¿Es obligatorio el seguro de viaje?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  <strong>Sí, es obligatorio.</strong> Todos los viajeros deben
                  estar cubiertos por un seguro de viaje que incluya asistencia
                  médica y repatriación. También recomendamos contratar un
                  seguro de cancelación para protegerte en caso de imprevistos.
                </p>
              </div>
            </div>

            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                📋 ¿Qué cubre el seguro de viaje?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  El seguro debe cubrir como mínimo asistencia médica y
                  repatriación. El seguro de cancelación opcional cubre los
                  gastos si necesitas cancelar el viaje por causas justificadas
                  (enfermedad, accidente, etc.). Te ayudamos a elegir el seguro
                  más adecuado para tu viaje.
                </p>
              </div>
            </div>

            <!-- Documentación -->
            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                📄 ¿Qué documentación necesito?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  Necesitarás pasaporte en vigor (con al menos 6 meses de
                  validez) y, según el destino, puede requerirse visado. Te
                  informaremos de todos los requisitos específicos para tu
                  destino. También es importante revisar las vacunas
                  recomendadas u obligatorias.
                </p>
              </div>
            </div>

            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                💉 ¿Necesito vacunas especiales?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  Dependiendo del destino, pueden requerirse ciertas vacunas. Te
                  proporcionaremos información sobre las vacunas recomendadas u
                  obligatorias para tu viaje. Es importante consultar con tu
                  médico o un centro de medicina tropical con suficiente
                  antelación.
                </p>
              </div>
            </div>

            <!-- Grupos y Viajes -->
            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                👥 ¿Cuál es el tamaño de los grupos?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  Trabajamos con grupos pequeños para garantizar una experiencia
                  más personalizada y auténtica. El tamaño del grupo varía según
                  el viaje, pero generalmente está entre 6 y 16 personas. Los
                  grupos pequeños nos permiten acceder a lugares únicos y
                  ofrecer un servicio más cercano.
                </p>
              </div>
            </div>

            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                🎯 ¿Puedo hacer un viaje personalizado?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  ¡Por supuesto! Ofrecemos viajes completamente personalizados
                  según tus intereses, fechas y presupuesto. Contáctanos para
                  contarnos qué tienes en mente y crearemos un itinerario único
                  para ti o tu grupo.
                </p>
              </div>
            </div>

            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                🏜️ ¿Qué nivel de dificultad tienen los viajes?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  Ofrecemos viajes para diferentes niveles, desde cómodos y
                  accesibles hasta más aventureros. En cada programa
                  especificamos el nivel de dificultad y los requisitos físicos.
                  Si tienes dudas sobre si un viaje es adecuado para ti,
                  consúltanos sin compromiso.
                </p>
              </div>
            </div>

            <!-- Qué incluye -->
            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                📦 ¿Qué incluyen los precios?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  Cada viaje incluye diferentes servicios que se detallan en la
                  ficha técnica. Generalmente incluyen alojamiento, transporte
                  terrestre, guías locales, y algunas comidas. Los vuelos
                  internacionales, visados, seguro y gastos personales no suelen
                  estar incluidos salvo que se especifique.
                </p>
              </div>
            </div>

            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                ✈️ ¿Incluyen los vuelos?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  La mayoría de nuestros viajes no incluyen vuelos
                  internacionales para darte flexibilidad en la elección de
                  compañía y horarios. Sin embargo, podemos ayudarte a encontrar
                  las mejores opciones de vuelo y, en algunos casos, incluirlos
                  en el paquete si lo prefieres.
                </p>
              </div>
            </div>

            <!-- Equipaje y Preparación -->
            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                🎒 ¿Qué debo llevar?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  Te proporcionaremos una lista detallada de equipaje
                  recomendado específica para tu viaje. Incluirá ropa adecuada
                  para el clima, calzado recomendado, artículos de higiene
                  personal, medicamentos y cualquier equipo especial necesario.
                  También te daremos consejos sobre las restricciones de
                  equipaje.
                </p>
              </div>
            </div>

            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                🌡️ ¿Cómo es el clima en los destinos?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  El clima varía mucho según el destino y la época del año. En
                  las fichas de cada viaje incluimos información sobre las
                  temperaturas esperadas y la mejor época para viajar. Te
                  recomendamos traer ropa para diferentes temperaturas,
                  especialmente en destinos desérticos donde puede hacer mucho
                  calor de día y frío de noche.
                </p>
              </div>
            </div>

            <!-- Durante el viaje -->
            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                📱 ¿Habrá conexión a internet?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  La disponibilidad de internet varía según el destino. En
                  ciudades principales suele haber wifi en hoteles y
                  restaurantes. En zonas más remotas o durante acampadas en el
                  desierto, la conexión puede ser limitada o inexistente. Te
                  informaremos sobre la cobertura esperada en tu itinerario
                  específico.
                </p>
              </div>
            </div>

            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                🍽️ ¿Qué pasa si tengo restricciones alimentarias?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  Podemos adaptar las comidas para vegetarianos, veganos,
                  celíacos y otras restricciones alimentarias. Es muy importante
                  que nos informes de cualquier alergia o restricción al hacer
                  la reserva para que podamos coordinarlo con nuestros
                  proveedores locales.
                </p>
              </div>
            </div>

            <!-- Emergencias -->
            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                🚨 ¿Qué pasa en caso de emergencia?
              </div>
              <div class="collapse-content">
                <p class="text-base-content/80">
                  Tenemos protocolos establecidos para diferentes tipos de
                  emergencias. Nuestros guías están formados en primeros
                  auxilios y tenemos contacto 24/7 con servicios de emergencia
                  locales. Tu seguro de viaje también proporcionará asistencia
                  en caso de emergencias médicas. Te daremos números de contacto
                  de emergencia antes del viaje.
                </p>
              </div>
            </div>

            <!-- Contacto -->
            <div class="collapse collapse-arrow bg-base-200">
              <input type="radio" name="faq-accordion" />
              <div class="collapse-title text-xl font-medium">
                📞 ¿Cómo puedo contactar con vosotros?
              </div>
              <div class="collapse-content">
                <div class="text-base-content/80">
                  <p class="mb-4">Puedes contactarnos por varios medios:</p>
                  <ul class="list-disc pl-6">
                    <li>
                      <strong>Email:</strong>
                      <a
                        href="mailto:info@soleando.eu"
                        class="text-primary hover:underline"
                        >info@soleando.eu</a
                      >
                    </li>
                    <li>
                      <strong>Teléfono:</strong> (+34) 608 76 29 62 / (+34) 620
                      50 17 61
                    </li>
                    <li>
                      <strong>Dirección:</strong> C/ Arturo Soria, 333 – 28033
                      Madrid, España
                    </li>
                  </ul>
                  <p class="mt-4">
                    Nuestro horario de atención es de lunes a viernes de 9:00 a
                    18:00h. Respondemos a los emails en un plazo máximo de 24
                    horas.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <section class="mt-12 bg-primary/10 p-8 rounded-lg text-center">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              ¿No encuentras la respuesta que buscas?
            </h2>
            <p class="text-base-content/80 mb-6">
              Nuestro equipo estará encantado de resolver todas tus dudas
              personalmente.
            </p>
            <div class="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="mailto:info@soleando.eu" class="btn btn-primary">
                📧 Enviar Email
              </a>
              <a href="tel:+34608762962" class="btn btn-outline btn-primary">
                📞 Llamar Ahora
              </a>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: "default",
});

useSeoMeta({
  title: "Preguntas Frecuentes (F.A.Q.) - Soleando",
  description:
    "Preguntas frecuentes sobre viajes al desierto y nuestros servicios. Encuentra respuestas a tus dudas sobre reservas, seguros, documentación y más.",
});
</script>

<style scoped></style>
